export default __webpack_public_path__ + "ac32ac1cb5e2ef1b9003579d5bbedeea.png";